<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M707.5 71.5H236.1c-66.8 0-121 54.2-121 121v638c0 66.8 54.2 121 121 121H786c66.8 0 121-54.2 121-121V271L707.5 71.5zm140.4 765.7c0 31-25.1 56.1-56.1 56.1h-561c-31 0-56.1-25.1-56.1-56.1V186.4c0-31 25.1-56.1 56.1-56.1h451.9l165.2 165.2v541.7z" data-follow-fill="currentColor" :fill="_fill" />
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M779.3 683.3c-16.1-10.7-37.8-6.2-48.5 9.9-17.4 26.4-34.4 35.7-46.5 38.6l-75.6-323.4 111.1-13c19.2-2.3 32.9-19.6 30.7-38.8-2.3-19.2-19.6-32.9-38.8-30.7l-119 14-18.7-80c-4.4-18.8-23.2-30.5-42.1-26.1-18.8 4.4-30.5 23.2-26.1 42.1l16.9 72.2-41.1 4.8c-19.2 2.3-32.9 19.6-30.7 38.8 2.1 17.8 17.2 30.9 34.7 30.9 1.4 0 2.7-.1 4.1-.2l48.9-5.7L622 773.3c2.7 11.5 11 20.8 22 24.9 2.8 1 14.1 4.8 30.5 4.8 6.7 0 14.2-.6 22.3-2.3 24.7-5 60.7-21 92.3-68.8 10.8-16.2 6.4-37.9-9.8-48.6z" />
        <circle r="40" cy="254.6" cx="664.9" />
        <path d="M455.8 242.1c.8-3 1.3-6.2 1.3-9.5 0-19.3-15.7-35-35-35-16 0-29.6 10.8-33.7 25.5v-.1c-.1.3-7.9 26.8-30.2 66.3-20.6 36.3-58 91.4-119.7 147.4-14.3 13-15.4 35.1-2.4 49.4 6.9 7.6 16.4 11.5 25.9 11.5 8.4 0 16.8-3 23.5-9.1 19-17.3 36.1-34.5 51.3-51.4v353.3c0 19.3 15.7 35 35 35s35-15.7 35-35v-446c33.7-54.3 46.4-94.1 48.6-101.3 0-.2.1-.3.1-.5.2-.2.2-.4.3-.5z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
